import React, { Component } from 'react'
import { Field } from 'redux-form';
import { reduxForm, formValueSelector } from 'redux-form';
import renderField from './renderField'
import { connect } from 'react-redux'



const validate = values => {

    const errors = {}
        if (!values["engagedwithmno"]){
            errors["engagedwithmno"] = 'Required'
          }    


    return errors
  }

class MNOConsultation extends Component {
  constructor(props) {
    super(props)
    this.state = {
      files: []
    }

    
  }
    getBase64 = file => {
        return new Promise(resolve => {
        let fileInfo;
        let baseURL = "";
        // Make new FileReader
        let reader = new FileReader();

        // Convert the file to base64 text
        reader.readAsDataURL(file);

        // on reader load somthing...
        reader.onload = () => {
            // Make a fileInfo Object
            baseURL = reader.result;
            //console.log(baseURL);
            resolve(baseURL);
        };
        });
    };

    handleFileInputChange = e => {
        let filelist = this.state.files
        let file = e.target.files[0];

        this.getBase64(file)
        .then(result => {
            file["base64"] = result;
            filelist.push({name:file.name, b64:result})
            this.modifyState({files:filelist})
        })
        .catch(err => {
            console.log(err);
        });

        


    };
    modifyState = (state) => {
        this.setState(state)
        this.props.updatePageState("MNOConsultation", this.state)
    }

    uploadedFileTable() {
        if (this.state.files.length===0){
            return (<React.Fragment></React.Fragment>)
        }
        let files = []
        for (let i in this.state.files){
            files.push(<tr key={i}>
                <td>{this.state.files[i].name}</td>
                <td><button onClick={()=>{
                    let tmp = this.state.files
                    tmp.splice(i,1)
                    this.setState({files:tmp})
                }}>Remove</button></td>
            </tr>)
        }
        return (<center>
            <table>
            <thead>
                <tr>
                    <th colSpan="2">Uploaded Files</th>
                </tr>
            </thead>
            <tbody>
                {files}
            </tbody>
        </table></center>)
    }

    componentDidMount() {
        if (this.props.getPageState("MNOConsultation")){
            this.setState(this.props.getPageState("MNOConsultation"));
            return;
        }
    
      }
    getIncumbentUserOfSelection() {
        const series_index = this.props.allPageStates.MapSelection.series_index;

        return series_index >= 0 ? this.props.allPageStates.MapSelection.series_lookup[series_index][2] : "";
    }

    getSelectedFrequencyRange() {
        const series_index = this.props.allPageStates.MapSelection.series_index;

        return series_index >= 0 ? `${this.props.allPageStates.MapSelection.series_lookup[this.props.allPageStates.MapSelection.series_index][0]} to ${this.props.allPageStates.MapSelection.series_lookup[this.props.allPageStates.MapSelection.series_index][1]} MHz` : "";
    }

    getContactDetailsForIncumbentUser(incumbentUser) {
        if (incumbentUser === "EE")
        return ["ee@nelsonbostock.com"];
        else if (incumbentUser === "O2")
        return ["pressoffice@O2.com"];
        else if (incumbentUser === "Vodafone")
        return ["brandmarketinguk@vodafone.com"];
        else if (incumbentUser === "Three")
        return ["three@headlandconsultancy.com", "3@itsprettygreen.com"];
        else
        return ["unknown"];
    }
    render() {
        var { handleSubmit, previousPage, engagedwithmno } = this.props;
    return (
        
        <React.Fragment>

          <h3>Step 5: Engage with <strong>{this.getIncumbentUserOfSelection()}</strong> and obtain their consent (recommended) <em>for Ofcom OfW588 form, Sections B1-2</em></h3>

          <p>Your LAL application is for <strong>{this.getSelectedFrequencyRange()}</strong>. The MNO <strong>{this.getIncumbentUserOfSelection()}</strong> hold a UK-wide licence for this frequency range. It is recommended that you engage with {this.getIncumbentUserOfSelection()} and obtain their consent prior to submitting your application to Ofcom.</p>
          <p>If you do not engage with {this.getIncumbentUserOfSelection()}, it is still possible that Ofcom will issue you a LAL, provided that {this.getIncumbentUserOfSelection()} have no current or planned use of the frequency range in the vicinity of your planned network. However, Ofcom (and we) recommend direct engagement first as this is more likely to result in a shorter application process with a favourable outcome.</p>
          <p>The correct contact details for engaging with {this.getIncumbentUserOfSelection()} on LALs are:
            {this.getContactDetailsForIncumbentUser(this.getIncumbentUserOfSelection()).map(email => (
              <React.Fragment key="key">
                <span> </span><a href="mailto:{email}">{email}</a>
              </React.Fragment>
              ))
            }.
          </p>
          

        <div className={'alert ' + (!this.state.files.length>0 ? 'alert-primary' : 'alert-success')} role="alert">
          {!this.state.files.length>0 ?
            <React.Fragment>Have you engaged with {this.getIncumbentUserOfSelection()} and obtained their consent?</React.Fragment> :
            <React.Fragment>You have uploaded evidence of your engagement with {this.getIncumbentUserOfSelection()}</React.Fragment>
          }
        </div>
        <form onSubmit={handleSubmit}>
        <div>
        <div>
          <label style={{ width: "800px"}}><Field name="engagedwithmno" component="input" type="radio" value="true"/> I have engaged with {this.getIncumbentUserOfSelection()} and obtained their consent</label>
          <label style={{ width: "800px"}}><Field name="engagedwithmno" component="input" type="radio" value="false"/>I have not engaged with {this.getIncumbentUserOfSelection()}, and wish to proceed anyway</label>
          <Field name="engagedwithmno" component={({ meta: { touched, error } }) =>
            touched && 
            error ? <span>{error}</span> : false
            } />
                    </div>
                    </div>
        { engagedwithmno==="true" && <React.Fragment><h3>Enter the following information for your contact at {this.getIncumbentUserOfSelection()}</h3>
        <Field
            name={"name"}
            type="text"
            component={renderField}
            disabled={this.props.disableFields}
            label="Name"
            placeholder="Enter name"
          />

          <Field
            name={"address"}
            type="text"
            component={renderField}
            disabled={this.props.disableFields}
            label="Address"
            placeholder="Enter the address"
          />
          <Field
            name={"postcode"}
            type="text"
            component={renderField}
            disabled={this.props.disableFields}
            label="Postcode"
            placeholder="Enter the postcode"
          />
          <Field
            name={"country"}
            type="text"
            component={renderField}
            disabled={this.props.disableFields}
            label="Country"
            placeholder="Enter the country"
          />
          <Field
            name={"telephone"}
            type="text"
            component={renderField}
            disabled={this.props.disableFields}
            label="Telephone"
            placeholder="Enter the telephone number"
          />
          <Field
            name={"mobile"}
            type="text"
            component={renderField}
            disabled={this.props.disableFields}
            label="Mobile"
            placeholder="Enter the mobile number"
          />
          <Field
            name={"fax"}
            type="text"
            component={renderField}
            disabled={this.props.disableFields}
            label="Fax"
            placeholder={this.props.disableFields ? "" : "Enter the fax number"}
          />
          <Field
            name={"email"}
            type="text"
            component={renderField}
            disabled={this.props.disableFields}
            label="Email"
            placeholder="Enter the email address"
          />
          <h3>Having engaged with {this.getIncumbentUserOfSelection()}, upload your correspondence - or a document giving a short summary - here, and it will be attached to your application as supporting evidence. </h3> </React.Fragment>}
          </form>
          {engagedwithmno==="true" &&this.uploadedFileTable()}
          <form onSubmit={handleSubmit}>
            {engagedwithmno==="true" &&<div style={{ margin: "auto", width: "552px"}}>
            <input type="file" accept=".pdf" onChange={this.handleFileInputChange}  />
            </div>}

            <div className="button-row">
              <button type="button" className="btn btn-light" disabled={false} onClick={this.props.previousPage}>
                Previous Page
              </button>
              <button type="button" className="btn btn-light" disabled={false} onClick={()=>{
                  this.props.saveAndExit()
                  }}>
                Save and Exit
              </button>
              <button type="submit" className="btn btn-primary" disabled={false} onClick={(e)=>console.log(e)}>Next Page</button>
            </div>

        </form>
      </React.Fragment>
    )
  }
}


MNOConsultation = reduxForm({
    form: 'userprofile', // a unique identifier for this form
    destroyOnUnmount: true, // <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    validate
  })(MNOConsultation)

  const selector = formValueSelector('userprofile')

  MNOConsultation = connect(
    state => {
      let engagedwithmno = selector(state, 'engagedwithmno')
  
      return {
        engagedwithmno
      }
    }
  )(MNOConsultation)

  export default MNOConsultation

